<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { Toast,Dialog } from "vant";
export default {
  name: "App",
  data() {
    return {
      appwebsock: null,
      websock: null
    };
  },
  mounted: function() {
    // 页面刚进入时开启长连接
    this.initWebSocket();
    this.initAppWebSocket();
  },
  destroyed: function() {
    // 页面销毁时关闭长连接
    this.websock.close()
    this.appwebsock.close()
    this.websock = null
    this.appwebsock = null
  },
  methods: {

    /**
     * 初始化weosocket
     */
    initWebSocket() {
      const wsUrl = process.env.WEBSOCKET_URL+`/${localStorage.getItem(
        "websocketPath"
      )}`;
      //建立连接
      this.websock = new WebSocket(wsUrl);
      //接收信息
      this.websock.onmessage = this.websocketonmessage;
      //连接成功
      this.websock.onopen = this.websocketonopen(wsUrl);
    },
    initAppWebSocket() {
      const wsUrl = process.env.APP_WEBSOCKET_URL+`/${localStorage.getItem(
        "websocketPath"
      )}`;
      //建立连接
      this.appwebsock = new WebSocket(wsUrl);
      //接收信息
      this.appwebsock.onmessage = this.websocketonmessage;
      this.appwebsock.onopen = this.appwebsocketonopen(wsUrl);
    },
    /**
     * 成功获取数据 接收数据
     */
    websocketonmessage(evt) {
      let _this = this;
      // 将socket接收到的值存进vuex
      let data = JSON.parse(evt.data);
      _this.$store.commit("setTemporaryChargeQueryResult", data);
      // 临停信息
      if (data.code === "ok") {
        console.log('websocket:',data)
        if (data.type === "discernRecordSend") {
          if (data.message) {
            let plateInfo = JSON.parse(data.message);
            _this.$store.commit("discernRecordSend", plateInfo);
          } else {
          }
        }
        if (data.type === "logSend") {
          if (data.message) {
            let plateInfo = JSON.parse(data.message);
            _this.$store.commit("logSend", plateInfo);
          } else {
          }
        }
        if (data.type === "p-ypt-temporaryCharge-query") {
          if (data.message) {
            _this.$store.commit("resetTemporaryData");
            _this.$store.commit("setTemporaryData", data.message);
          } else {
          }
        }
        // 月租信息
        if (data.type === "p-ypt-getMonthRentTime-query") {
          if (data.message) {
            _this.$store.commit("resetMonthData");
            _this.$store.commit("setMonthData", data.message);
          } else {
            Toast("暂无包月时长可选择");
            _this.$store.commit("resetMonthData");
          }
        }
        // 储值信息
        if (data.type === 'p-ypt-getStoredValue-query') {
          console.log('储值信息:',data.message, data.message.storedValue)
          if (data.message) {
            // 只更新储值余额，不重置其他数据（如车牌号和停车场信息）
            _this.$store.commit('stored/SETSTOREDBALANCE', data.message.storedValue);
          } else {
            Toast('暂无储值信息');
            // 当没有储值信息时，仍使用UPDATESTOREDBALANCE保持其他数据不变
            _this.$store.commit('stored/SETSTOREDBALANCE', '未获取');
          }
        }
        // app
        if (data.type === "p-app-present-plate-query"
          || data.type === "p-app-un-paid-record-query"
          || data.type === "p-app-pay-record-query"
          || data.type === "p-app-open-gate-record-query"
          || data.type === "p-app-black-list-query"
          || data.type === "p-app-fixed-plate-query"
          || data.type === "p-app-fixed-plate-list-query"
          || data.type === "p-app-vehicle-owner-list-query"
          || data.type === "p-app-recharge-record-query"
          || data.type === "p-app-charge-total-query"
          || data.type === "p-app-recharge-record-query"
        ) {
          if (data.message) {
            _this.$store.commit("setDataList", data.message);
          } else {
          }
        }
        if (data.type === "p-app-present-plate-delete"
          || data.type === "p-app-black-list-add"
          || data.type === "p-app-black-list-delete"
          || data.type === "p-app-fixed-plate-add"
          || data.type === "p-app-fixed-plate-update"
          || data.type === "p-app-fixed-plate-charge"
          || data.type === "p-app-fixed-plate-delete") {
          if (data) {
            _this.$store.commit("setAction", data.action);
          } else {
          }
        }
        if (data.type === "p-app-gate-info-query") {
          if (data.message) {
            _this.$store.commit("setGateInfoList", data.message);
          } else {
          }
        }
        if (data.type === "p-app-recharge-total-query") {
          if (data.message) {
            _this.$store.commit("setRechargeTotal", data.message[0]);
          } else {
          }
        }
        if (data.type === "p-app-noneLicensePlate-approach") {
          if (data) {
            _this.$store.commit("setNoneLicensePlateMessage", data);
          } else {
          }
        }
        if (data.type === "p-app-parking-lot-config-query") {
          if (data) {
            _this.$store.commit("setParkingLotConfig", data.message[0]);
          } else {
          }
        }
      } else {
        console.log('websocket 消息异常:'+data)
        Toast('消息异常');
      }
    },
    websocketonopen(url){
      console.log("连接成功："+url)
    },
    appwebsocketonopen(url){
      console.log("连接成功："+url)
      this.$store.commit("setWebSocket", this.appwebsock);
    }
  }
};
</script>

<style lang="less" scoped>
  /deep/ .van-nav-bar__title {
    font-size: 14px;color: #000000;
  }
  /deep/ .van-icon-arrow-left {
    font-size: 18px;color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue